export default __webpack_public_path__ + "static/media/dm.29411c9a.svg";